import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowCircleDownComponent } from "./med-icon-arrow-circle-down.component";

@NgModule({
  declarations: [
    MedIconArrowCircleDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowCircleDownComponent,
  ],
})
export class MedIconArrowCircleDownModule { }
